import { useQuery } from "react-query";
import { Product } from "../models";
import { IProduct } from "../types";
import { useCache } from "../context/CacheContext";
import { useWorkspace } from "../context/WorkspaceContext";
import { useUserSession } from "../context/UserContext";
import { listProducts } from "../data/api/products";
import { queryKeys } from "../data/queryKeys";

/**
 * Workspace products, read through the REST API (previously a direct Firestore
 * query). Query key, cache-key invalidation and `Product[]` instance return
 * shape are preserved, so existing consumers and `updateCacheKey()` keep working.
 */
const useProducts = (workspaceId?: string) => {
  const { cacheKey } = useCache();
  const { activeWorkspace } = useWorkspace();
  const { userSession, isAuthenticated } = useUserSession();
  const resolvedWorkspaceId = workspaceId ?? activeWorkspace?.workspaceId ?? "";
  const token = userSession?.token?.accessToken;

  return useQuery<Product[], Error>(
    queryKeys.products(cacheKey, resolvedWorkspaceId),
    async () => {
      const products = await listProducts(token as string, resolvedWorkspaceId);
      return products.map((product: IProduct) => new Product(product));
    },
    {
      enabled: !!token && !!resolvedWorkspaceId && isAuthenticated(),
    },
  );
};

export default useProducts;
